
import { Component, Prop, Vue } from 'vue-property-decorator'
import { CustomerListDto } from "@/api/customerManage";
import { Action, Getter } from "vuex-class";
import { isPermitEnterShop } from "@/api/shoppingMall";
import Clipboard from 'clipboard';

@Component({
  name: 'CustomerCard'
})
export default class CustomerCard extends Vue {
  @Prop({ default: () => ({}) }) data!: CustomerListDto
  @Prop({ default:'' }) action!: string
  @Action setProviderId!: (val: string) => void;
  @Getter companyId!: string
  /**
   * 跳转到店铺首页
   * @param id 店铺id
   */
  toShopHome (obj: CustomerListDto) {
    if (!this.$isAction('shopHome')) {
      return false
    }
    const params = {
      shopId: obj.merchantsId,
      customerId: this.companyId
    }
    isPermitEnterShop(params).then((res) => {
      if (res.code === '000000') {
        this.setProviderId(obj.merchantsId)
        this.$router.push({ path: '/storeHome', query: { shopHomeTitle: obj.merchantsName } })
      }else if(res.code === '000002'){
        this.$toast(res.msg)
      }
    })
  }

  /**
   * 打开详情页
   * @param e
   * @param id 关联id
   * @param merchantsId 客户编号
   */
  toDetail (id: string, merchantsId: string) {
    if(!this.$isAction(this.action))return false
    this.$router.push({
      path: '/customerDetail',
      query: {
        relationId: id,
        merchantsId: merchantsId
      }
    })
  }

  /**
   * @description: 折叠板展开收起事件
   * @param {*} isOpen
   * @return {*}
   */
  onToggle (isOpen) {
    this.$set(this.data, 'isOpen', !isOpen);
    (this.$refs.collapseItem as any).toggle(!isOpen)
  }

  /**
   * @description: 监听复制
   * @param {*} e 复制内容
   * @return {*}
   */
  copyCode (key) {
    let clipboard = new Clipboard('.copy', {
      text: trigger => key
    })
    clipboard.on('success', e => {
      this.$toast('复制成功')
    })
    clipboard.on('error', e => {
      this.$toast('该浏览器不支持复制')
      e.clearSelection()
    })
  }
}
